import './TtsConfig.css';
import { useState } from 'react';
import Dropdown from '/src/components/UI/DropDown/DropDown';
import TextInput from '/src/components/UI/TextField/TextInput';
import { TTS_SERVICES, TTS_PARAMS } from '/src/features/editor/data/constant/tts/ttsServices';

function TtsConfig({ value, onChange }) {
    const parseValue = (val) => {
        if (!val) return { vendor: TTS_SERVICES[0].value };
        try {
            return typeof val === 'string' ? JSON.parse(val) : val;
        } catch {
            return { vendor: TTS_SERVICES[0].value };
        }
    };

    const [config, setConfig] = useState(() => parseValue(value));

    const updateConfig = (newConfig) => {
        setConfig(newConfig);
        onChange(JSON.stringify(newConfig));
    };

    const onVendorChange = (_, vendor) => {
        const params = TTS_PARAMS[vendor] || [];
        const defaults = params.reduce((acc, param) => {
            acc[param.key] = param.default;
            return acc;
        }, {});
        updateConfig({ vendor, ...defaults });
    };

    const onParamChange = (key, val) => {
        updateConfig({ ...config, [key]: val });
    };

    const vendor = config.vendor || TTS_SERVICES[0].value;
    const params = TTS_PARAMS[vendor] || [];

    return (
        <div className="tts-config">
            <div className="tts-config-row">
                <label className="tts-config-label">Service</label>
                <div className="tts-config-field">
                    <Dropdown
                        choices={TTS_SERVICES}
                        defaultChoice={vendor}
                        setValue={onVendorChange}
                        name="vendor"
                        width="250px"
                        hideSelectItem={false}
                    />
                </div>
            </div>
            {params.map((param) => (
                <div className="tts-config-row" key={param.key}>
                    <label className="tts-config-label">{param.label}</label>
                    <div className="tts-config-field">
                        {param.type === 'dropdown' ? (
                            <Dropdown
                                choices={param.options.map(o => ({ value: o, text: o }))}
                                defaultChoice={config[param.key] !== undefined ? config[param.key] : param.default}
                                setValue={(_, val) => onParamChange(param.key, val)}
                                name={param.key}
                                width="250px"
                                hideSelectItem={false}
                            />
                        ) : (
                            <TextInput
                                type={param.type === 'number' ? 'number' : 'text'}
                                value={config[param.key] !== undefined ? config[param.key] : param.default}
                                onChange={(e) => onParamChange(param.key, param.type === 'number' ? Number(e.target.value) : e.target.value)}
                                className="tts-config-input"
                                placeholder={param.label}
                            />
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default TtsConfig;
